import React from "react"
import { connect } from "react-redux"
import { Flex, Box } from "@rebass/grid/emotion"
import styled from "@emotion/styled"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"

import Logo from "./logo"
import BackButton from "./backbutton"
import SaveAndExitButton from "../../components/saveandexitbutton"
import ProgressBar from "../../components/progressbar"

const HeaderWrap = styled.header`
  position: fixed;
  z-index: 4;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 85px;
  &.mousedown {
    *:focus {
      outline: none;
    }
  }
  &.intro-mode {
      @media (max-width: 767px) {
          > div {
              padding-left: 24px;
              padding-right: 24px;
              background-color: rgba(255, 255, 255, 0.5);
              box-shadow: none;
              border-radius: 4px;
          }
      }
  }
  @media (min-width: 768px) {
    transition: top .2s;
    top: 8px;
    left: 8px;
    right: 8px;
    width: calc(100% - 16px);
    height: 108px;
  }
  @media (min-width: 1024px) {
    height: 120px;
    top: 24px;
    left: 24px;
    right: 24px;
    width: calc(100% - 48px);
  }
  @media (min-width: 1568px) {
    max-width: 1520px;
    left: calc(50% - 760px);
  }
`
const MainHeaderFlex = styled(Flex)`
  background: ${theme.color.white};
  height: 56px;
  box-shadow: 0px 1px 0px #C8D2D1;
  @media (min-width: 768px) {
    border-radius: 8px;
    height: 72px;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.05), 0px 24px 38px rgba(0, 0, 0, 0.03), 0px 9px 46px rgba(0, 0, 0, 0.03), 0px 11px 15px rgba(0, 0, 0, 0.03);    
  }
  @media (min-width: 1024px) {
    height: 80px;
  }
`

const Header = props => {

  return (
    <>
      {!props.interstitial || (props.interstitial && props.showNameGreeting) ? (
        <HeaderWrap 
          className={(props.isIntroMode ? " intro-mode " : "") + (props.mouseDown ? " mousedown " : "") + " header-wrapper"}
        >
          <MainHeaderFlex className="wrap" alignItems="center" height="100%" px={[2, 2, "32px"]}>
            <Box width={["calc(50% - 73px)", null, "calc(50% - 62px)"]} className="back-wrap">
              <BackButton quizData={props.quizData} />
            </Box>
            <Box width={["146px", null, "146px"]} className="logo-wrap">
              <Logo />
            </Box>
            <Box width={["calc(50% - 73px)", null, "calc(50% - 62px)"]} className="text-right exit-wrap">
              <SaveAndExitButton />
            </Box>
          </MainHeaderFlex>
          <ProgressBar />
        </HeaderWrap>
      ) : null}
    </>
  )
}

const mapStateToProps = state => {
  return {
    isIntroMode: state.setHeaderVariantReducer.isIntroMode,
    isMhmd: state.setIsMhmdReducer.isMhmd,
    interstitial: state.interstitialReducer.interstitial,
    showNameGreeting: state.revealProgressReducer.showNameGreeting,
  }
}

export default connect(mapStateToProps)(Header)
